import React from "react";
import styles from "./ProfileAchievementDetailsModal.module.css";
import type { ProfileAchievementItemViewModel } from "../types/view-models";

type ProfileAchievementDetailsModalProps = {
  achievement: ProfileAchievementItemViewModel | null;
  onClose: () => void;
};

function getRequirementCopy(achievement: ProfileAchievementItemViewModel): string[] {
  const lines: string[] = [];

  if (achievement.requirements.noDisputesRequired) {
    lines.push(
      achievement.requirements.noDisputesMet
        ? "No active disputes requirement met"
        : "Requires no active disputes",
    );
  }

  if (achievement.requirements.noStrikesRequired) {
    lines.push(
      achievement.requirements.noStrikesMet
        ? "No strikes requirement met"
        : "Requires no strikes",
    );
  }

  return lines;
}

export default function ProfileAchievementDetailsModal({
  achievement,
  onClose,
}: ProfileAchievementDetailsModalProps) {
  if (!achievement) return null;

  const requirementCopy = getRequirementCopy(achievement);
  const stopModalClick = (event: { stopPropagation: () => void }) => event.stopPropagation();

  return (
    <div className={styles.overlay || ""} role="dialog" aria-modal="true" aria-labelledby="achievement-modal-title" onClick={onClose}>
      <div
        className={styles.modal || ""}
        onClick={stopModalClick}
      >
        <button type="button" className={styles.closeButton || ""} onClick={onClose} aria-label="Close achievement details">
          ×
        </button>
        <div className={styles.header || ""}>
          <div>
            <div className={styles.eyebrow || ""}>{achievement.category}</div>
            <h3 id="achievement-modal-title" className={styles.title || ""}>{achievement.name}</h3>
          </div>
          <span className={styles.tierChip || ""}>Tier {achievement.tier}</span>
        </div>

        <p className={styles.description || ""}>{achievement.description}</p>

        <div className={styles.statBlock || ""}>
          <span className={styles.statLabel || ""}>Progress</span>
          <span className={styles.statValue || ""}>{achievement.progress.label}</span>
        </div>

        {requirementCopy.length > 0 ? (
          <div className={styles.requirements || ""}>
            {requirementCopy.map((line) => (
              <div key={line} className={styles.requirementItem || ""}>
                {line}
              </div>
            ))}
          </div>
        ) : null}

        {achievement.unlockedAt ? (
          <div className={styles.footer || ""}>
            Unlocked {new Date(achievement.unlockedAt).toLocaleDateString("en-US", {
              month: "short",
              day: "numeric",
              year: "numeric",
            })}
          </div>
        ) : null}
      </div>
    </div>
  );
}
